import React from "react";

export default function SVBFaqSearchEmptyResult(props){
    const {searchParam} = props;
    return(
        <div className="svb-faq-search-empty-results position-relative pt-2">
            <p>Did you mean: <span>{searchParam}</span></p>
            <div className="no-faq-result-text">
                <p>Sorry, no results match your search.</p>
            </div>
        </div>
    );
}
